const SpeciesFuturesPool = {
  "_format": "hh-sol-artifact-1",
  "contractName": "SpeciesFuturesPool",
  "sourceName": "contracts/core/SpeciesFuturesPool.sol",
  "abi": [
    {
      "inputs": [],
      "name": "BAD_INDEX",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "BAD_INPUT",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "CLOSE_AFTER_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "DEPOSITS_CLOSED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "E_TO",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "FINALIZE_BEFORE_CLAIM",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "LEN",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_FINALIZED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NOT_REDEEMABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_SHARES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "NO_USDC",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "POOL_EMPTY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "SLIPPAGE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "TOO_EARLY",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "UNREDEEMED",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_SPECIES",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_STABLE",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "WRONG_TIMESTAMP",
      "type": "error"
    },
    {
      "inputs": [],
      "name": "ZERO",
      "type": "error"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Approval",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "sharesMinted",
          "type": "uint256"
        }
      ],
      "name": "Deposited",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "totalUSDC",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPerShareWad",
          "type": "uint256"
        }
      ],
      "name": "Finalized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": false,
          "internalType": "uint8",
          "name": "version",
          "type": "uint8"
        }
      ],
      "name": "Initialized",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "user",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "sharesBurned",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "name": "SharesRedeemed",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "value",
          "type": "uint256"
        }
      ],
      "name": "Transfer",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": true,
          "internalType": "address",
          "name": "project",
          "type": "address"
        }
      ],
      "name": "UnderlyingAdded",
      "type": "event"
    },
    {
      "anonymous": false,
      "inputs": [
        {
          "indexed": true,
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "indexed": true,
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "indexed": false,
          "internalType": "uint256",
          "name": "usdcReceived",
          "type": "uint256"
        }
      ],
      "name": "UnderlyingRedeemed",
      "type": "event"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "owner",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        }
      ],
      "name": "allowance",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "approve",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "account",
          "type": "address"
        }
      ],
      "name": "balanceOf",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "claimTimestamp",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "decimals",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "subtractedValue",
          "type": "uint256"
        }
      ],
      "name": "decreaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address[]",
          "name": "investmentTokens",
          "type": "address[]"
        },
        {
          "internalType": "uint256[]",
          "name": "tokenIds",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "amounts",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256",
          "name": "minSharesOut",
          "type": "uint256"
        }
      ],
      "name": "deposit",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "sharesOut",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "depositCloseTime",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "depositSingle",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "sharesOut",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "estimateValue",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "totalUSDC",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "estimatedPerShareWad",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "factory",
      "outputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalizeEarliestTime",
      "outputs": [
        {
          "internalType": "uint64",
          "name": "",
          "type": "uint64"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "finalized",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "getAllUnderlyings",
      "outputs": [
        {
          "components": [
            {
              "internalType": "address",
              "name": "investmentToken",
              "type": "address"
            },
            {
              "internalType": "bool",
              "name": "redeemed",
              "type": "bool"
            },
            {
              "internalType": "uint256",
              "name": "tokenId",
              "type": "uint256"
            },
            {
              "internalType": "uint256",
              "name": "balance",
              "type": "uint256"
            }
          ],
          "internalType": "struct SpeciesFuturesPool.UnderlyingToken[]",
          "name": "",
          "type": "tuple[]"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "index",
          "type": "uint256"
        }
      ],
      "name": "getUnderlying",
      "outputs": [
        {
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        },
        {
          "internalType": "bool",
          "name": "redeemed",
          "type": "bool"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "spender",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "addedValue",
          "type": "uint256"
        }
      ],
      "name": "increaseAllowance",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "factory_",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "stableCoin_",
          "type": "address"
        },
        {
          "internalType": "uint8",
          "name": "speciesId_",
          "type": "uint8"
        },
        {
          "internalType": "uint64",
          "name": "claimTimestamp_",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "depositCloseTime_",
          "type": "uint64"
        },
        {
          "internalType": "uint64",
          "name": "finalizeEarliestTime_",
          "type": "uint64"
        },
        {
          "internalType": "string",
          "name": "name_",
          "type": "string"
        },
        {
          "internalType": "string",
          "name": "symbol_",
          "type": "string"
        }
      ],
      "name": "initialize",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "name",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "uint256[]",
          "name": "",
          "type": "uint256[]"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155BatchReceived",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        },
        {
          "internalType": "bytes",
          "name": "",
          "type": "bytes"
        }
      ],
      "name": "onERC1155Received",
      "outputs": [
        {
          "internalType": "bytes4",
          "name": "",
          "type": "bytes4"
        }
      ],
      "stateMutability": "pure",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "redeemAllUnderlyings",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "shareAmount",
          "type": "uint256"
        }
      ],
      "name": "redeemShares",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "shareAmount",
          "type": "uint256"
        }
      ],
      "name": "redeemSharesTo",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "usdcPaid",
          "type": "uint256"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256[]",
          "name": "indices",
          "type": "uint256[]"
        }
      ],
      "name": "redeemUnderlyings",
      "outputs": [],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "settledUSDCRemaining",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "speciesId",
      "outputs": [
        {
          "internalType": "uint8",
          "name": "",
          "type": "uint8"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "stableCoin",
      "outputs": [
        {
          "internalType": "contract IERC20",
          "name": "",
          "type": "address"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "symbol",
      "outputs": [
        {
          "internalType": "string",
          "name": "",
          "type": "string"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "totalSupply",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transfer",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "address",
          "name": "from",
          "type": "address"
        },
        {
          "internalType": "address",
          "name": "to",
          "type": "address"
        },
        {
          "internalType": "uint256",
          "name": "amount",
          "type": "uint256"
        }
      ],
      "name": "transferFrom",
      "outputs": [
        {
          "internalType": "bool",
          "name": "",
          "type": "bool"
        }
      ],
      "stateMutability": "nonpayable",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "underlyingCount",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "name": "underlyings",
      "outputs": [
        {
          "internalType": "address",
          "name": "investmentToken",
          "type": "address"
        },
        {
          "internalType": "bool",
          "name": "redeemed",
          "type": "bool"
        },
        {
          "internalType": "uint256",
          "name": "tokenId",
          "type": "uint256"
        },
        {
          "internalType": "uint256",
          "name": "balance",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    },
    {
      "inputs": [],
      "name": "usdcPerShareWad",
      "outputs": [
        {
          "internalType": "uint256",
          "name": "",
          "type": "uint256"
        }
      ],
      "stateMutability": "view",
      "type": "function"
    }
  ],
  "bytecode": "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",
  "deployedBytecode": "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",
  "linkReferences": {},
  "deployedLinkReferences": {}
};

export default SpeciesFuturesPool;
